import { Box, StepConnector } from "@mui/material";
import styled from "styled-components";
import vector from "../../../assets/images/vector.png";

export const MultiStepFormStyled = styled(Box)`
  .MuiStepper-root {
    max-width: 768px;
    margin: 0 auto;
    .MuiStep-root {
      .MuiStepLabel-root {
        .MuiStepLabel-iconContainer {
          z-index: 1;
          &.Mui-active,
          &.Mui-completed {
            position: relative;
            overflow: hidden;
            .MuiSvgIcon-root {
              color: var(--royal-blue-color);
              border: none;
            }
            &::after {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 100%;
              background-color: var(--royal-blue-color);
              border-radius: 50%;
              z-index: 1;
            }
          }
          .MuiSvgIcon-root {
            width: 20px;
            height: 20px;
            background-color: var(--soft-medium-gray-color);
            color: var(--soft-medium-gray-color);
            border: 1px solid #2460b880;
            border-radius: 50%;
            text {
              display: none;
            }
          }
        }
        .MuiStepLabel-labelContainer {
          .MuiStepLabel-label {
            &.Mui-active,
            &.Mui-completed {
              color: var(--royal-blue-color);
            }
            margin-top: 8px;
            font-weight: 500;
            font-size: 14px;
            color: #969ba0;
          }
        }
      }
    }
  }
  .bottom-button {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 14px;

    @media (max-width: 768px) {
      display: flex;
      flex-direction: row;
      width: 100%;
      div {
        width: 100%;
        button {
          width: 100%;
        }
      }
    }
  }
`;

export const Connector = styled(StepConnector)`
  top: 10px !important;
  width: 100%;
  left: auto !important;
  right: calc(100% - 50%) !important;
  .MuiStepConnector-line {
    border: none;
    height: 2px;
    background: url(${vector}) no-repeat center;
  }
`;

export const Content = styled(Box)`
  padding: 52px 0;

  @media (max-width: 576px) {
    .bottom-button {
      width: 100%;
      margin-top: 16px;
      .MuiBox-root {
        width: 100% !important;
        display: block !important;
        button {
          width: 100%;
        }
      }
    }
  }
`;

export const ContinueButtonContainer = styled(Box)`
  display: flex;
  justify-content: right;
  .primary-button {
    .MuiButtonBase-root {
      min-width: 254px;
    }
    @media (max-width: 768px) {
      .MuiButtonBase-root {
        min-width: unset;
      }
    }
  }
`;
